import { ShieldCheck } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#d97706";
const SEZIONI = [
  { id: "intro", titolo: "Anteprima del modulo" },
  { id: "pratiche", titolo: "Pratiche cauzioni" },
  { id: "wizard", titolo: "Nuova pratica" },
  { id: "parere", titolo: "Parere ed esito" },
  { id: "relazione", titolo: "Relazione tecnica con AI" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeCauzioni() {
  return (
    <ManualeLayout titolo="CauzioniPro (anteprima)" sottotitolo="Gestione pratiche di cauzione — modulo in completamento" icona={ShieldCheck} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="Anteprima del modulo" accent={A}>
        <Callout tipo="warn">CauzioniPro è nella sezione <b>Work in Progress</b>: le funzioni sono in fase di completamento e possono cambiare. Questo è un manuale di anteprima.</Callout>
        <P>Il modulo gestisce le <b>pratiche di cauzione/garanzia</b>: raccolta dati del cliente, profilazione (anche con supporto AI dal sito web del cliente), parere e registrazione dell'esito.</P>
      </Scheda>

      <Scheda id="pratiche" n="2" titolo="Pratiche cauzioni" accent={A}>
        <P>La sezione <b>Pratiche</b> elenca le posizioni con <b>ricerca</b> per ragione sociale o P.IVA e filtri per <b>stato</b> ed <b>esito</b>. Da qui apri il dettaglio di una pratica.</P>
      </Scheda>

      <Scheda id="wizard" n="3" titolo="Nuova pratica" accent={A}>
        <Steps items={[
          "Cerca il cliente in anagrafica (ragione sociale o P.IVA) o inseriscilo.",
          "Indica la forma giuridica e, se disponibile, il sito web (usato per il profilo AI).",
          "Completa i dati della pratica e salva.",
        ]} />
      </Scheda>

      <Scheda id="parere" n="4" titolo="Parere ed esito" accent={A}>
        <Bullets items={[
          "Registra il parere con il relativo giudizio.",
          "Aggiorna lo stato e l'esito della pratica man mano che avanza.",
        ]} />
      </Scheda>

      <Scheda id="relazione" n="5" titolo="Relazione tecnica con AI" accent={A}>
        <P>Dal dettaglio pratica il pulsante <b>Genera con AI</b> (o <b>Rigenera AI</b>) produce la relazione tecnica assuntiva analizzando i documenti allegati e il profilo del cliente.</P>
        <Steps items={[
          "Assicurati che i documenti obbligatori e il parere siano presenti.",
          "Clicca 'Genera con AI': l'elaborazione parte in background e la pagina mostra 'Analisi documenti in corso…'.",
          "L'operazione può richiedere 1–2 minuti (più documenti = più tempo): puoi restare sulla pagina, la relazione comparirà automaticamente al termine.",
        ]} />
        <Callout tipo="info">La generazione avviene in background proprio per gestire correttamente i documenti voluminosi senza interruzioni. Se impiega troppo, riprova più tardi.</Callout>
      </Scheda>

      <Scheda id="faq" n="6" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Posso già usarlo in produzione?", a: "È un modulo in lavorazione: usalo con prudenza; alcune funzioni (es. invio email) potrebbero non essere ancora attive." },
          { q: "A cosa serve il sito web del cliente?", a: "Alimenta la profilazione assistita da AI per inquadrare meglio l'attività del cliente." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
